import { OrderIncidentType, OrderIncidentTypes } from 'src/constants/OrderIncidentType';

export function isIncorrectOrderIncident(orderIncidentType: OrderIncidentType | undefined): boolean {
    return orderIncidentType === OrderIncidentTypes.INCORRECT_ORDER;
}
